import { IPublicClientApplication } from "@azure/msal-browser";

import { axiosGetRequest, axiosPatchRequest } from "../../api/ApiClient";
import GenericUtils from "../../utils/GenericUtils";
import { IWorkflowFilter } from "../../context/interfaces/IWorkflowContext";

const route = "docente/v1/workflows";

const generateFilterURL = (filter: IWorkflowFilter) => {
    let URL = route;

    if (filter.workflowTypeId) {
        URL += `/${filter.workflowTypeId}`;
    }

    URL += "/processos?";

    if (filter.status) {
        URL += `workflowStatus=${filter.status.toUpperCase()}&`;
    }

    if (filter.searchName) {
        URL += `nomeSolicitante=${filter.searchName}&`;
    }

    if (filter.initialDate && filter.finalDate) {
        URL += `dataRange=${filter.initialDate}...${filter.finalDate}&`;
    }

    if (filter.pageSize) {
        URL += `_limit=${filter.pageSize}&`;
    }

    if (filter.actualPage >= 0 || filter.actualPage) {
        URL += `_offset=${filter.actualPage}`;
    }

    return URL;
};

const getWorkflowsByFilter = (
    filter: IWorkflowFilter,
    instance: IPublicClientApplication
) => {
    const URL = generateFilterURL(filter);

    return axiosGetRequest(URL, GenericUtils.getAccessTokenDocente(), instance);
};

const patchProcessTach = (
    msalInstance: IPublicClientApplication,
    processId: string,
    filteredItem?: object
) => {
    return axiosPatchRequest(
        `${route}/5/processos/${processId}`,
        filteredItem,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
};

const getDocTachById = (
    instance: IPublicClientApplication,
    processId: string
) => {
    return axiosGetRequest(
        `${route}/5/processos/${processId}`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
};

const getWorkflowTypes = (instance: IPublicClientApplication) => {
    return axiosGetRequest(
        route,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
};

export default {
    getWorkflowsByFilter,
    getWorkflowTypes,
    getDocTachById,
    patchProcessTach,
};
